import React, { useEffect, useState } from "react";
import "./QuestionType.css";
import CheckBoxType from "./CheckBoxType";
import SucessfullySubmited from "./SucessfullySubmited";
import SubmisshionByUpload from "./SubmisshionByUpload";
import { useSelector } from "react-redux";
import axios from "../../../../axios";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import AllQuestionRequired from "../../../../DcmDetails/SelfAssessment/Popup/AllQuestionRequired";
import ConfirmPopup from "./ConfirmPopup";

export default function AllQuestions({ type }) {
  const { homeworkId, selfAssessmentId } = useParams();
  const { state } = useLocation();
  const [pendingData, setPendingData] = useState();
  const [isGettingData, setIsGettingData] = useState(true);
  const [isSubmitProcessing, setIsSubmitProcessing] = useState(false);
  const [finalAttachment, setFinalAttachment] = useState([]);
  const [isNotAllQuestionAnswered, setIsNotAllQuestionAnswered] =
    useState(false);
  const [allQuestions, setAllQuestions] = useState([]);
  const [confirmPopupOpen, setConfirmPopupOpen] = useState(false);
  const navigate = useNavigate();
  const receiveDataFromChild = (data) => {
    setFinalAttachment(data);
  };
  const userId = useSelector((state) => state.user?.currentUser?.id);
  const getHWQuestionResponse = async () => {
    try {
      let updatedQuestion = [];
      let tempAllQuestion = [];
      let res = await axios.get(`/homework/get/${state.homeworkId}`);
      res &&
        res.data.data?.questions.forEach((question, index) => {
          tempAllQuestion.push(question)
          if (!question.type.is_manually_graded) {
            updatedQuestion.push({
              question_id: question?.id,
              answer: {
                key: " ",
                explanation: " ",
              },
              mandatory: question?.is_mandatory,
              index,
            });
          } else {
            updatedQuestion.push({
              question_id: question?.id,
              description: " ",
              attachments: [],
              mandatory: question?.is_mandatory,
              index,
            });
          }
        });
      setAllQuestions(tempAllQuestion);
      setQuestionsAnswer([...updatedQuestion]);
      res && setPendingData(res.data.data);
      setIsGettingData(false);
    } catch (error) {
      console.log(error);
      setIsGettingData(false);
    }
  };

  const getSAQuestionResponse = async () => {
    try {
      let updatedQuestion = [];
      let tempAllQuestion = [];
      let res = await axios.get(`/selfAssess/get/${state.selfAssessmentId}`);
      if (res.data.data?.questions.length == 0 && res.data.data?.b4sQuestions.length == 0) {
        toast.info("Qustions not available");
        navigate(-1);
      }
      if (res) {
        res.data.data?.questions.forEach((question, index) => {
          tempAllQuestion.push(question)
          if (!question.type.is_manually_graded) {
            updatedQuestion.push({
              questionSource: "question",
              question_id: question?.id,
              answer: {
                key: " ",
                explanation: " ",
              },
              mandatory: question?.is_mandatory,
              index,
            });
          } else {
            updatedQuestion.push({
              questionSource: "question",
              question_id: question?.id,
              description: " ",
              attachments: [],
              mandatory: question?.is_mandatory,
              index,
            });
          }
        });
        res.data.data?.b4sQuestions.forEach((question, index) => {
          tempAllQuestion.push(question)
          if (!question.type.is_manually_graded) {
            updatedQuestion.push({
              questionSource: "b4s",
              question_id: question?.id,
              answer: {
                key: " ",
                explanation: " ",
              },
              mandatory: question?.is_mandatory,
              index,
            });
          } else {
            updatedQuestion.push({
              questionSource: "b4s",
              question_id: question?.id,
              description: " ",
              attachments: [],
              mandatory: question?.is_mandatory,
              index,
            });
          }
        });
      }
      setAllQuestions(tempAllQuestion);
      setQuestionsAnswer([...updatedQuestion]);
      res && setPendingData(res.data.data);
      console.log("pending data : ", res.data.data);
      setIsGettingData(false);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (type == "HW") {
      getHWQuestionResponse();
    } else if (type == "SA") {
      getSAQuestionResponse();
      // console.log("SA api not defined")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [questionNo, setQuestionNo] = useState(0);
  const [allQuestion, setAllQuestion] = useState({
    sucessful: false,
  });

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate().toString().padStart(2, "0");
    const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, "0");
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${day}/${month}/${year}`;
    return outputDateString;
  };

  const handleSucessfulyfalse = () => {
    setAllQuestion({
      ...allQuestion,
      sucessful: false,
    });
  };

  const [questionsAnswer, setQuestionsAnswer] = useState([]);

  const handleSubmit = async (assessmentId, assessmentType) => {
    setIsSubmitProcessing(true);
    try {
      if (type == "SA") {
        let notAnswer = questionsAnswer.filter(
          (answer) => answer.answer.key == " "
        );
        if (notAnswer.length > 0) {
          setIsNotAllQuestionAnswered(true);
          return;
        }

        let qustionAnswer = [];
        let b4sQuestionAnswer = [];
        questionsAnswer.map((answer) => {
          if (answer.questionSource == 'b4s') {
            delete answer.questionSource;
            b4sQuestionAnswer.push(answer)
          } else if (answer.questionSource == 'question') {
            delete answer.questionSource;
            qustionAnswer.push(answer);
          }
        })
        if (type == "SA") {
          let selfAssessmentBody = {
            student_id: userId,
            submitted_on: new Date(),
            questionanswers: qustionAnswer,
            b4squestionanswers: b4sQuestionAnswer,
          };
          let res = await axios.post(`/${assessmentType}/${assessmentId}/studentResponse/create`, selfAssessmentBody);
          res && setAllQuestion({ ...allQuestion, sucessful: true });
        } else {
          let selfAssessmentBody = {
            student_id: userId,
            submitted_on: new Date(),
            answers: questionsAnswer,
          };
          let res = await axios.post(`/${assessmentType}/${assessmentId}/studentResponse/create`, selfAssessmentBody);
          res && setAllQuestion({ ...allQuestion, sucessful: true });
        }

      } else {
        let selfAssessmentBody = {
          student_id: userId,
          submitted_on: new Date(),
          answers: questionsAnswer,
        };
        let res = await axios.post(`/${assessmentType}/${assessmentId}/studentResponse/create`, selfAssessmentBody);
        res && setAllQuestion({ ...allQuestion, sucessful: true });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message ?? "Something went wrong");
      console.log(error);
    }
    setIsSubmitProcessing(false);
  };
  let From = localStorage.getItem("From");
  return (
    <>
      {pendingData && allQuestions.length > 0 ? (
        <div className="d-flex gap-1">
          <div>
            <img
              style={{ cursor: "pointer" }}
              onClick={() => {
                From === "DCM" ? navigate("/Calender") : navigate(-1);
              }}
              src="/HwImg/backArrow.png"
              alt=""
            />
            &nbsp;
          </div>
          <div className="hederContainer1">
            <div>
              <div className="d-flex justify-content-between w-100  ">
                <div>
                  <span className="quesHeading">{pendingData?.name}</span>
                </div>
                <div>
                  <div style={{ textAlign: "right" }}>
                    <span className="subTitles">Total Marks</span> &nbsp;
                    <span className="quesHeading">
                      {pendingData?.total_marks}
                    </span>
                  </div>
                  <div>
                    <span className="subTitles">This Question</span> &nbsp;
                    <span className="quesHeading">
                      {allQuestions[questionNo]?.correct_score}
                    </span>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-between w-100 mt-1">
                {type == "SA" ? (
                  <div>
                    <span className="subTitle2">
                      {pendingData?.subject?.name}
                    </span>{" "}
                    <span>|</span> &nbsp;
                    <span className="subTitles3">Created</span> &nbsp;
                    <span className="subTitle2">
                      {timeHelper(pendingData?.created_at)}
                    </span>
                  </div>
                ) : (
                  <div>
                    <span className="subTitle2">
                      {pendingData?.subject_id?.name}
                    </span>
                    <span>|</span> &nbsp;
                    <span className="subTitles3">Deadline</span> &nbsp;
                    <span className="subTitle2">
                      {timeHelper(pendingData?.deadline)}
                    </span>
                  </div>
                )}
                <div className="subTitle2">
                  Questions: {questionNo + 1}/{allQuestions?.length}
                </div>
              </div>
            </div>
            <div style={{ fontSize: "18px", fontWeight: "500", margin: "15px 0px" }}>{pendingData?.description}</div>
            <div className="mt-3 d-flex gap-2">
              {allQuestions?.length > 0 &&
                allQuestions?.map((item, index) => (
                  <div
                    onClick={(e) => setQuestionNo(index)}
                    className={
                      questionNo > index
                        ? "QuestionActiveNo"
                        : "QuestionNoNonActive"
                    }
                    style={{
                      borderColor:
                        questionNo === index
                          ? "#F99933"
                          : questionNo > index
                            ? "#F77F00"
                            : "#668598",
                      color:
                        questionNo === index
                          ? "#F99933"
                          : questionNo > index
                            ? "#F77F00"
                            : "#668598",
                      backgroundColor:
                        questionNo > index ? "#FEF2E5" : "transparent",
                    }}
                  >
                    Q{index + 1}
                  </div>
                ))}
            </div>

            <div className="mt-4 allquestionTypesContainer" style={{ height: "83%" }}>
              {!allQuestions[questionNo]?.type?.is_manually_graded ? (
                <CheckBoxType
                  questionNo={questionNo + 1}
                  question={allQuestions[questionNo]}
                  setQuestionsAnswer={setQuestionsAnswer}
                  questionsAnswer={questionsAnswer}
                />
              ) : (
                <SubmisshionByUpload
                  receiveDataFromChild={receiveDataFromChild}
                  questionNo={questionNo + 1}
                  question={allQuestions[questionNo]}
                  setQuestionsAnswer={setQuestionsAnswer}
                  questionsAnswer={questionsAnswer}
                />
              )}

              <div className="d-flex gap-2 justify-content-end" style={{ marginRight: "26px" }}>
                {questionNo >= 1 && (
                  <button
                    className="PreviousBtnQue"
                    onClick={(e) => setQuestionNo(questionNo - 1)}
                  >
                    Previous
                  </button>
                )}

                {allQuestions?.length > questionNo + 1 ? (
                  <button
                    className="nextBtnQue"
                    onClick={(e) => setQuestionNo(questionNo + 1)}
                  >
                    Next
                  </button>
                ) : (
                  <button
                    className={`nextBtnQue ${isSubmitProcessing ? 'disabled' : ''}`}
                    disabled={isSubmitProcessing}
                    onClick={() => setConfirmPopupOpen(true)}
                  >
                    Submit
                  </button>
                )}
              </div>
            </div>
          </div>

          {allQuestion.sucessful && (
            <SucessfullySubmited
              type={type}
              handleSucessfulyfalse={handleSucessfulyfalse}
            />
          )}
          {isNotAllQuestionAnswered && (
            <AllQuestionRequired
              setIsNotAllQuestionAnswered={setIsNotAllQuestionAnswered}
            />
          )}
          {confirmPopupOpen && <ConfirmPopup setConfirmPopupOpen={setConfirmPopupOpen} type={type} handleSubmit={handleSubmit} state={state} />}
        </div>
      ) : isGettingData ? (
        <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
          <img
            className="ongoing_internal_loader"
            src="/gif/LoaderDot.gif"
            alt=""
          />
        </div>
      ) : (
        <div className="ContainerPendingSubDetail d-flex p-4 gap-1">
          <span>
            {type == "SA" ? "Self-Assessment " : "Homework "} Not Found
          </span>
        </div>
      )}
    </>
  );
}
